import { whenRefAvailable } from "@/utilities";
import { readonly, type Ref } from "vue";

type DialogInstance = {
  open: () => void;
  close: () => void;
};

export function useDialogControls(dialogRef: Ref<DialogInstance | null>) {
  const open = () => whenRefAvailable(dialogRef).then((dialog) => dialog.value?.open());
  const close = () => whenRefAvailable(dialogRef).then((dialog) => dialog.value?.close());

  return {
    open,
    close,
    dialogRef: readonly(dialogRef),
  };
}
